
/**
 * @preserve
 * @name a11y-vue-dialog
 * @version 0.6.0
 * @license: MIT
 * © Renato de Leão <renatodeleao@gmail.com>
*/
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global['a11y-vue-dialog'] = {}));
}(this, (function (exports) { 'use strict';

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  //
  //
  //
  //
  //
  //
  //
  //
  //
  var MODES = [false, true, 'auto'];
  var script = {
    name: "Skeleton",
    props: {
      scrollable: {
        type: [Boolean, String],
        "default": false,
        validator: function validator(v) {
          return MODES.indexOf(v) > -1;
        }
      },
      tag: {
        type: String,
        "default": "div"
      }
    },
    computed: {
      scrollableClass: function scrollableClass() {
        return this.scrollable ? this.scrollable === "auto" ? 'o-skeleton--scrollable-auto' : 'o-skeleton--scrollable' : null;
      },
      classList: function classList() {
        return ['o-skeleton', _defineProperty({}, this.scrollableClass, this.scrollable)];
      }
    }
  };

  function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
  /* server only */
  , shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
      createInjectorSSR = createInjector;
      createInjector = shadowMode;
      shadowMode = false;
    } // Vue.extend constructor export interop.


    var options = typeof script === 'function' ? script.options : script; // render functions

    if (template && template.render) {
      options.render = template.render;
      options.staticRenderFns = template.staticRenderFns;
      options._compiled = true; // functional template

      if (isFunctionalTemplate) {
        options.functional = true;
      }
    } // scopedId


    if (scopeId) {
      options._scopeId = scopeId;
    }

    var hook;

    if (moduleIdentifier) {
      // server build
      hook = function hook(context) {
        // 2.3 injection
        context = context || // cached call
        this.$vnode && this.$vnode.ssrContext || // stateful
        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
        // 2.2 with runInNewContext: true

        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
          context = __VUE_SSR_CONTEXT__;
        } // inject component styles


        if (style) {
          style.call(this, createInjectorSSR(context));
        } // register component module identifier for async chunk inference


        if (context && context._registeredComponents) {
          context._registeredComponents.add(moduleIdentifier);
        }
      }; // used by ssr in case component is cached and beforeCreate
      // never gets called


      options._ssrRegister = hook;
    } else if (style) {
      hook = shadowMode ? function () {
        style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
      } : function (context) {
        style.call(this, createInjector(context));
      };
    }

    if (hook) {
      if (options.functional) {
        // register for functional component in vue file
        var originalRender = options.render;

        options.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        // inject component registration as beforeCreate hook
        var existing = options.beforeCreate;
        options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }

    return script;
  }

  var normalizeComponent_1 = normalizeComponent;

  /* script */
  var __vue_script__ = script;
  /* template */

  var __vue_render__ = function __vue_render__() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c(_vm.tag, _vm._g({
      tag: "component",
      "class": _vm.classList
    }, _vm.$listeners), [_vm._t("outisde-skeleton-elements"), _vm._v(" "), _vm.$slots["skeleton-head"] ? _c("div", {
      staticClass: "o-skeleton__tip"
    }, [_vm._t("skeleton-head")], 2) : _vm._e(), _vm._v(" "), _c("div", {
      staticClass: "o-skeleton__body"
    }, [_vm._t("default")], 2), _vm._v(" "), _vm.$slots["skeleton-feet"] ? _c("div", {
      staticClass: "o-skeleton__tip"
    }, [_vm._t("skeleton-feet")], 2) : _vm._e()], 2);
  };

  var __vue_staticRenderFns__ = [];
  __vue_render__._withStripped = true;
  /* style */

  var __vue_inject_styles__ = undefined;
  /* scoped */

  var __vue_scope_id__ = undefined;
  /* module identifier */

  var __vue_module_identifier__ = undefined;
  /* functional template */

  var __vue_is_functional_template__ = false;
  /* style inject */

  /* style inject SSR */

  var Skeleton = normalizeComponent_1({
    render: __vue_render__,
    staticRenderFns: __vue_staticRenderFns__
  }, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

  var FOCUSABLE_ELEMENTS = ['a[href]:not([tabindex^="-"]):not([inert])', 'area[href]:not([tabindex^="-"]):not([inert])', 'input:not([disabled]):not([inert])', 'select:not([disabled]):not([inert])', 'textarea:not([disabled]):not([inert])', 'button:not([disabled]):not([inert])', 'iframe:not([tabindex^="-"]):not([inert])', 'audio:not([tabindex^="-"]):not([inert])', 'video:not([tabindex^="-"]):not([inert])', '[contenteditable]:not([tabindex^="-"]):not([inert])', '[tabindex]:not([tabindex^="-"]):not([inert])'];

  var getInitialState = function getInitialState() {
    return {
      dialogEl: null,
      focusable: [],
      trigger: null,
      portalTarget: null,
      siblingsCount: 0
    };
  };

  var script$1 = {
    name: "a11y-vue-dialog",
    components: {
      Skeleton: Skeleton
    },
    props: {
      /**
      * @desc must match to globally/locall registered portal-vue portalName
      */
      portalName: {
        type: String,
        "default": "portal"
      },

      /**
       * @desc must mach an existent portal-vue portal-target
       */
      portalTargetName: {
        type: [String, null],
        "default": "a11y-vue-dialogs"
      },

      /**
       * @desc control's dialog visibility
       */
      open: {
        type: Boolean,
        "default": false
      },

      /**
       * @desc add overflow hidden to app root
       */
      preventBackgroundScrolling: {
        type: Boolean,
        "default": true
      },

      /**
       * @desc accessibilty attribute: possible usage as modal
       * @url https://github.com/edenspiekermann/a11y-dialog#usage-as-a-modal
       */
      role: {
        type: String,
        "default": "dialog",
        validator: function validator(v) {
          return ["dialog", "alertdialog"].indexOf(v) > -1;
        }
      },

      /**
       * @desc accessibilty attribute: hide content from screen readers
       * when dialog is open. if null, defaults to siblings of portal-target element
       */
      contentRoot: {
        type: [String, null],
        "default": null
      },

      /**
       * @desc classname that will prefix all HTML element
       * @note opininated, BEM selectors will be created for each element.
       * if using with sass, you should also match $avd-classname variable
       * before import styles. More on styling
       */
      baseClassname: {
        type: [String],
        "default": "c-dialog",
        validator: function validator(val) {
          return val !== "";
        }
      }
    },
    data: function data() {
      return getInitialState();
    },
    computed: {
      classObj: function classObj() {
        var _ref;

        return _ref = {}, _defineProperty(_ref, this.baseClassname, true), _defineProperty(_ref, "".concat(this.baseClassname, "--is-open"), this.open), _ref;
      }
    },
    watch: {
      open: {
        immediate: true,
        handler: function handler(open) {
          var _this = this;

          if (open) {
            this.handleBackgroundScrolling(true);
            this.$nextTick(function () {
              _this.$emit('open', _this);

              _this.openDuties();
            });
          } else {
            this.handleBackgroundScrolling(false);
            this.resetData();
          }
        }
      }
    },
    methods: {
      openDuties: function openDuties() {
        var _this2 = this;

        this.trigger = document.activeElement;
        this.$nextTick(function () {
          _this2.dialogEl = _this2.$refs.dialog.$el;

          _this2.lookForSiblings();

          _this2.$refs.close.focus();

          _this2.getFocusableChildren();

          _this2.observeContents(true);

          _this2.ariaHandler(true);
        });
      },
      dismiss: function dismiss() {
        this.observeContents();
        this.ariaHandler(false);

        if (this.trigger) {
          this.trigger.focus();
        }

        this.$emit('close');
      },
      handleBackdropClick: function handleBackdropClick(e) {
        if (e.target === this.$refs.backdrop) {
          this.dismiss();
        }
      },

      /**
       * [1] fix jump due removal of scrollbar
       * only works beacause neither body or #app has height 100%;
       */
      handleBackgroundScrolling: function handleBackgroundScrolling(open) {
        if (this.preventBackgroundScrolling) {
          if (this.siblingsCount > 1) return;
          var body = document.body.style;
          var app = this.$root.$el.style;

          if (open) {
            body.setProperty("overflow", "hidden");
            app.setProperty("overflow-y", "scroll"); // [1]
          } else {
            body.removeProperty("overflow", "hidden");
            app.removeProperty("overflow-y", "scroll"); // [1]
          }
        }
      },
      resetData: function resetData() {
        Object.assign(this.$data, getInitialState());
      },
      // experimental for multiple modals
      lookForSiblings: function lookForSiblings() {
        this.portalTarget = this.$refs.backdrop.parentElement;
        this.siblingsCount = this.portalTarget.children.length;
      },
      //----------------
      // All credits to Hugo Giraudel for this
      // https://github.com/edenspiekermann/a11y-dialog/blob/master/a11y-dialog.js
      //
      // adapted to this instance
      // ----------------

      /**
       * Get all focusable element inside dialog
       */
      getFocusableChildren: function getFocusableChildren() {
        this.focusable = [].slice.call(this.dialogEl.querySelectorAll(FOCUSABLE_ELEMENTS.join(',')));
      },

      /**
       * Trap the focus inside the given element
       *
       * @param {Event} event
       */
      trapFocus: function trapFocus(event) {
        this.getFocusableChildren(); // maybe we can cache and apply MutationObserver to watch for new ones

        var focusedItemIndex = this.focusable.indexOf(document.activeElement); // If the SHIFT key is being pressed while tabbing (moving backwards) and
        // the currently focused item is the first one, move the focus to the last
        // focusable item from the dialog element

        if (event.shiftKey && focusedItemIndex === 0) {
          this.focusable[this.focusable.length - 1].focus();
          event.preventDefault(); // If the SHIFT key is not being pressed (moving forwards) and the currently
          // focused item is the last one, move the focus to the first focusable item
          // from the dialog element
        } else if (!event.shiftKey && focusedItemIndex === this.focusable.length - 1) {
          this.focusable[0].focus();
          event.preventDefault();
        }
      },

      /**
       * A default MutationObserver to watch for newly
       * added content and possibly new focusable elements
       */
      observeContents: function observeContents(bool) {
        var _this3 = this;

        if (bool) {
          var callback = function callback(mutationsList) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = mutationsList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var mutation = _step.value;

                if (mutation.type == 'childList') {
                  _this3.getFocusableChildren();
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                  _iterator["return"]();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          };

          this.observer = new MutationObserver(callback);
          this.observer.observe(this.dialogEl, {
            childList: true,
            subtree: true
          });
        } else {
          if (this.observer) this.observer.disconnect();
        }
      },
      //-------------------------
      // ACESSIBILITY ATTRIBUTES
      //-------------------------

      /**
       * https://gomakethings.com/an-es6-way-to-get-all-sibling-elements-with-vanilla-js/
       */
      getSiblings: function getSiblings(elem) {
        return [].filter.call(elem.parentNode.children, function (sibling) {
          return sibling !== elem;
        });
      },
      ariaHandler: function ariaHandler(bool) {
        // if theres already one open dialog, we don't need to toggle everything again.
        if (this.siblingsCount > 1) return;
        var contentRoot = this.contentRoot;
        var contentRootSiblings = []; // check if content-root prop is not null, in affirmative case
        // we just want to target it, nothing else

        if (contentRoot) {
          contentRootSiblings.push(document.querySelector(contentRoot));
        } else if (this.portalTarget) {
          // if not, we default to find the same level elements (siblings)
          // and apply aria-attributes to them
          contentRootSiblings = this.getSiblings(this.portalTarget);
        }

        if (bool) {
          contentRootSiblings.map(function (s) {
            return s.setAttribute('aria-hidden', 'true');
          });
        } else {
          contentRootSiblings.map(function (s) {
            return s.removeAttribute('aria-hidden');
          });
        }
      }
    }
  };

  /* script */
  var __vue_script__$1 = script$1;
  /* template */

  var __vue_render__$1 = function __vue_render__() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _vm.open ? _c(_vm.portalName, {
      tag: "component",
      attrs: {
        to: _vm.portalTargetName
      }
    }, [_c("div", {
      ref: "backdrop",
      "class": _vm.classObj,
      attrs: {
        id: "dialog-" + _vm._uid
      },
      on: {
        click: _vm.handleBackdropClick
      }
    }, [_c("skeleton", {
      ref: "dialog",
      "class": _vm.baseClassname + "__inner",
      attrs: {
        role: _vm.role,
        "aria-labelledby": "dialog-title",
        "aria-describedby": "dialog-desc",
        scrollable: "auto"
      },
      on: {
        keydown: [function ($event) {
          if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
            return null;
          }

          return _vm.dismiss($event);
        }, function ($event) {
          if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) {
            return null;
          }

          return _vm.trapFocus($event);
        }]
      }
    }, [_c("header", {
      "class": _vm.baseClassname + "__header",
      attrs: {
        slot: "skeleton-head"
      },
      slot: "skeleton-head"
    }, [_c("h1", {
      "class": _vm.baseClassname + "__title",
      attrs: {
        id: "dialog-title"
      }
    }, [_vm._t("a11y-vue-dialog-title", [_vm._v("Dialog Title")])], 2), _vm._v(" "), _c("div", {
      ref: "close",
      "class": _vm.baseClassname + "__close",
      attrs: {
        tabindex: "0",
        type: "button",
        "aria-label": "Close this dialog window"
      },
      on: {
        click: _vm.dismiss,
        keydown: [function ($event) {
          if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
            return null;
          }

          $event.preventDefault();
          return _vm.dismiss($event);
        }, function ($event) {
          if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) {
            return null;
          }

          return _vm.dismiss($event);
        }]
      }
    }, [_vm._t("a11y-vue-dialog-close", [_vm._v("\n            ×\n          ")])], 2)]), _vm._v(" "), _c("section", {
      "class": _vm.baseClassname + "__body",
      attrs: {
        id: "dialog-desc"
      }
    }, [_vm._t("default")], 2), _vm._v(" "), _vm.$slots["a11y-vue-dialog-footer"] ? _c("footer", {
      "class": _vm.baseClassname + "__footer",
      attrs: {
        slot: "skeleton-feet"
      },
      slot: "skeleton-feet"
    }, [_vm._t("a11y-vue-dialog-footer")], 2) : _vm._e()])], 1)]) : _vm._e();
  };

  var __vue_staticRenderFns__$1 = [];
  __vue_render__$1._withStripped = true;
  /* style */

  var __vue_inject_styles__$1 = undefined;
  /* scoped */

  var __vue_scope_id__$1 = undefined;
  /* module identifier */

  var __vue_module_identifier__$1 = undefined;
  /* functional template */

  var __vue_is_functional_template__$1 = false;
  /* style inject */

  /* style inject SSR */

  var A11yVueDialog = normalizeComponent_1({
    render: __vue_render__$1,
    staticRenderFns: __vue_staticRenderFns__$1
  }, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, undefined, undefined);

  /*!
  * tabbable 5.1.1
  * @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
  */
  var candidateSelectors = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])', 'details>summary'];
  var candidateSelector =
  /* #__PURE__ */
  candidateSelectors.join(',');
  var matches = typeof Element === 'undefined' ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

  function tabbable(el, options) {
    options = options || {};
    var regularTabbables = [];
    var orderedTabbables = [];
    var candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable);
    candidates.forEach(function (candidate, i) {
      var candidateTabindex = getTabindex(candidate);

      if (candidateTabindex === 0) {
        regularTabbables.push(candidate);
      } else {
        orderedTabbables.push({
          documentOrder: i,
          tabIndex: candidateTabindex,
          node: candidate
        });
      }
    });
    var tabbableNodes = orderedTabbables.sort(sortOrderedTabbables).map(function (a) {
      return a.node;
    }).concat(regularTabbables);
    return tabbableNodes;
  }

  function getCandidates(el, includeContainer, filter) {
    var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));

    if (includeContainer && matches.call(el, candidateSelector)) {
      candidates.unshift(el);
    }

    candidates = candidates.filter(filter);
    return candidates;
  }

  function isNodeMatchingSelectorTabbable(node) {
    if (!isNodeMatchingSelectorFocusable(node) || isNonTabbableRadio(node) || getTabindex(node) < 0) {
      return false;
    }

    return true;
  }

  function isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || isHiddenInput(node) || isHidden(node)) {
      return false;
    }

    return true;
  }

  var focusableCandidateSelector =
  /* #__PURE__ */
  candidateSelectors.concat('iframe').join(',');

  function isFocusable(node) {
    if (!node) {
      throw new Error('No node provided');
    }

    if (matches.call(node, focusableCandidateSelector) === false) {
      return false;
    }

    return isNodeMatchingSelectorFocusable(node);
  }

  function getTabindex(node) {
    var tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);

    if (!isNaN(tabindexAttr)) {
      return tabindexAttr;
    } // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // so if they don't have a tabindex attribute specifically set, assume it's 0.


    if (isContentEditable(node)) {
      return 0;
    } // in Chrome, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0


    if ((node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO') && node.getAttribute('tabindex') === null) {
      return 0;
    }

    return node.tabIndex;
  }

  function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
  }

  function isContentEditable(node) {
    return node.contentEditable === 'true';
  }

  function isInput(node) {
    return node.tagName === 'INPUT';
  }

  function isHiddenInput(node) {
    return isInput(node) && node.type === 'hidden';
  }

  function isRadio(node) {
    return isInput(node) && node.type === 'radio';
  }

  function isNonTabbableRadio(node) {
    return isRadio(node) && !isTabbableRadio(node);
  }

  function getCheckedRadio(nodes, form) {
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].checked && nodes[i].form === form) {
        return nodes[i];
      }
    }
  }

  function isTabbableRadio(node) {
    if (!node.name) {
      return true;
    }

    var radioScope = node.form || node.ownerDocument;
    var radioSet = radioScope.querySelectorAll('input[type="radio"][name="' + node.name + '"]');
    var checked = getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
  }

  function isHidden(node) {
    if (getComputedStyle(node).visibility === 'hidden') return true;

    while (node) {
      if (getComputedStyle(node).display === 'none') return true;
      node = node.parentElement;
    }

    return false;
  }

  /*!
  * focus-trap 6.1.2
  * @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
  */

  function _defineProperty$1(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2$1(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys$1(Object(source), true).forEach(function (key) {
          _defineProperty$1(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys$1(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var activeFocusDelay;

  var activeFocusTraps = function () {
    var trapQueue = [];
    return {
      activateTrap: function activateTrap(trap) {
        if (trapQueue.length > 0) {
          var activeTrap = trapQueue[trapQueue.length - 1];

          if (activeTrap !== trap) {
            activeTrap.pause();
          }
        }

        var trapIndex = trapQueue.indexOf(trap);

        if (trapIndex === -1) {
          trapQueue.push(trap);
        } else {
          // move this existing trap to the front of the queue
          trapQueue.splice(trapIndex, 1);
          trapQueue.push(trap);
        }
      },
      deactivateTrap: function deactivateTrap(trap) {
        var trapIndex = trapQueue.indexOf(trap);

        if (trapIndex !== -1) {
          trapQueue.splice(trapIndex, 1);
        }

        if (trapQueue.length > 0) {
          trapQueue[trapQueue.length - 1].unpause();
        }
      }
    };
  }();

  function createFocusTrap(element, userOptions) {
    var doc = document;
    var container = typeof element === 'string' ? doc.querySelector(element) : element;

    var config = _objectSpread2$1({
      returnFocusOnDeactivate: true,
      escapeDeactivates: true,
      delayInitialFocus: true
    }, userOptions);

    var state = {
      firstTabbableNode: null,
      lastTabbableNode: null,
      nodeFocusedBeforeActivation: null,
      mostRecentlyFocusedNode: null,
      active: false,
      paused: false
    };
    var trap = {
      activate: activate,
      deactivate: deactivate,
      pause: pause,
      unpause: unpause
    };
    return trap;

    function activate(activateOptions) {
      if (state.active) return;
      updateTabbableNodes();
      state.active = true;
      state.paused = false;
      state.nodeFocusedBeforeActivation = doc.activeElement;
      var onActivate = activateOptions && activateOptions.onActivate ? activateOptions.onActivate : config.onActivate;

      if (onActivate) {
        onActivate();
      }

      addListeners();
      return trap;
    }

    function deactivate(deactivateOptions) {
      if (!state.active) return;
      clearTimeout(activeFocusDelay);
      removeListeners();
      state.active = false;
      state.paused = false;
      activeFocusTraps.deactivateTrap(trap);
      var onDeactivate = deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate;

      if (onDeactivate) {
        onDeactivate();
      }

      var returnFocus = deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate;

      if (returnFocus) {
        delay(function () {
          tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
        });
      }

      return trap;
    }

    function pause() {
      if (state.paused || !state.active) return;
      state.paused = true;
      removeListeners();
    }

    function unpause() {
      if (!state.paused || !state.active) return;
      state.paused = false;
      updateTabbableNodes();
      addListeners();
    }

    function addListeners() {
      if (!state.active) return; // There can be only one listening focus trap at a time

      activeFocusTraps.activateTrap(trap); // Delay ensures that the focused element doesn't capture the event
      // that caused the focus trap activation.

      activeFocusDelay = config.delayInitialFocus ? delay(function () {
        tryFocus(getInitialFocusNode());
      }) : tryFocus(getInitialFocusNode());
      doc.addEventListener('focusin', checkFocusIn, true);
      doc.addEventListener('mousedown', checkPointerDown, {
        capture: true,
        passive: false
      });
      doc.addEventListener('touchstart', checkPointerDown, {
        capture: true,
        passive: false
      });
      doc.addEventListener('click', checkClick, {
        capture: true,
        passive: false
      });
      doc.addEventListener('keydown', checkKey, {
        capture: true,
        passive: false
      });
      return trap;
    }

    function removeListeners() {
      if (!state.active) return;
      doc.removeEventListener('focusin', checkFocusIn, true);
      doc.removeEventListener('mousedown', checkPointerDown, true);
      doc.removeEventListener('touchstart', checkPointerDown, true);
      doc.removeEventListener('click', checkClick, true);
      doc.removeEventListener('keydown', checkKey, true);
      return trap;
    }

    function getNodeForOption(optionName) {
      var optionValue = config[optionName];
      var node = optionValue;

      if (!optionValue) {
        return null;
      }

      if (typeof optionValue === 'string') {
        node = doc.querySelector(optionValue);

        if (!node) {
          throw new Error('`' + optionName + '` refers to no known node');
        }
      }

      if (typeof optionValue === 'function') {
        node = optionValue();

        if (!node) {
          throw new Error('`' + optionName + '` did not return a node');
        }
      }

      return node;
    }

    function getInitialFocusNode() {
      var node;

      if (getNodeForOption('initialFocus') !== null) {
        node = getNodeForOption('initialFocus');
      } else if (container.contains(doc.activeElement)) {
        node = doc.activeElement;
      } else {
        node = state.firstTabbableNode || getNodeForOption('fallbackFocus');
      }

      if (!node) {
        throw new Error('Your focus-trap needs to have at least one focusable element');
      }

      return node;
    }

    function getReturnFocusNode(previousActiveElement) {
      var node = getNodeForOption('setReturnFocus');
      return node ? node : previousActiveElement;
    } // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event.


    function checkPointerDown(e) {
      if (container.contains(e.target)) {
        // allow the click since it ocurred inside the trap
        return;
      }

      if (config.clickOutsideDeactivates) {
        // immediately deactivate the trap
        deactivate({
          // if, on deactivation, we should return focus to the node originally-focused
          //  when the trap was activated (or the configured `setReturnFocus` node),
          //  then assume it's also OK to return focus to the outside node that was
          //  just clicked, causing deactivation, as long as that node is focusable;
          //  if it isn't focusable, then return focus to the original node focused
          //  on activation (or the configured `setReturnFocus` node)
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked, whether it's focusable or not; by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node)
          returnFocus: config.returnFocusOnDeactivate && !isFocusable(e.target)
        });
        return;
      } // This is needed for mobile devices.
      // (If we'll only let `click` events through,
      // then on mobile they will be blocked anyways if `touchstart` is blocked.)


      if (config.allowOutsideClick && (typeof config.allowOutsideClick === 'boolean' ? config.allowOutsideClick : config.allowOutsideClick(e))) {
        // allow the click outside the trap to take place
        return;
      } // otherwise, prevent the click


      e.preventDefault();
    } // In case focus escapes the trap for some strange reason, pull it back in.


    function checkFocusIn(e) {
      // In Firefox when you Tab out of an iframe the Document is briefly focused.
      if (container.contains(e.target) || e.target instanceof Document) {
        return;
      }

      e.stopImmediatePropagation();
      tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
    }

    function checkKey(e) {
      if (config.escapeDeactivates !== false && isEscapeEvent(e)) {
        e.preventDefault();
        deactivate();
        return;
      }

      if (isTabEvent(e)) {
        checkTab(e);
        return;
      }
    } // Hijack Tab events on the first and last focusable nodes of the trap,
    // in order to prevent focus from escaping. If it escapes for even a
    // moment it can end up scrolling the page and causing confusion so we
    // kind of need to capture the action at the keydown phase.


    function checkTab(e) {
      updateTabbableNodes();

      if (e.shiftKey && e.target === state.firstTabbableNode) {
        e.preventDefault();
        tryFocus(state.lastTabbableNode);
        return;
      }

      if (!e.shiftKey && e.target === state.lastTabbableNode) {
        e.preventDefault();
        tryFocus(state.firstTabbableNode);
        return;
      }
    }

    function checkClick(e) {
      if (config.clickOutsideDeactivates) return;
      if (container.contains(e.target)) return;

      if (config.allowOutsideClick && (typeof config.allowOutsideClick === 'boolean' ? config.allowOutsideClick : config.allowOutsideClick(e))) {
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();
    }

    function updateTabbableNodes() {
      var tabbableNodes = tabbable(container);
      state.firstTabbableNode = tabbableNodes[0] || getInitialFocusNode();
      state.lastTabbableNode = tabbableNodes[tabbableNodes.length - 1] || getInitialFocusNode();
    }

    function tryFocus(node) {
      if (node === doc.activeElement) return;

      if (!node || !node.focus) {
        tryFocus(getInitialFocusNode());
        return;
      }

      node.focus({
        preventScroll: !!config.preventScroll
      });
      state.mostRecentlyFocusedNode = node;

      if (isSelectableInput(node)) {
        node.select();
      }
    }
  }

  function isSelectableInput(node) {
    return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
  }

  function isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
  }

  function isTabEvent(e) {
    return e.key === 'Tab' || e.keyCode === 9;
  }

  function delay(fn) {
    return setTimeout(fn, 0);
  }

  var noop = function noop() {}; // @see [FT3]


  var AUTOFOCUS_QUERY = 'input[autofocus], button[autofocus], select[autofocus], textarea[autofocus]';
  /**
   * @see spyMouseDown|spyMouseUp - [1]
   */

  var getInitialState$1 = function getInitialState() {
    return {
      id: null,
      dialogEl: null,
      closeEl: null,
      focusRef: null,
      trap: null,
      portalTarget: null,
      siblingsCount: 0,
      mouseDownOrigin: null // [1]

    };
  };

  var VALID_ROLES = ["dialog", "alertdialog"];
  var script$2 = {
    name: "a11y-vue-dialog-renderless",
    props: {
      /**
       * @desc control's dialog visibility
       */
      open: {
        type: Boolean,
        "default": false
      },

      /**
       * @desc accessibilty attribute: possible usage as modal. If "alertdialog"
       * will not close on backdrop click.
       * @see https://github.com/edenspiekermann/a11y-dialog#usage-as-a-modal
       */
      role: {
        type: String,
        "default": "dialog",
        validator: function validator(role) {
          return VALID_ROLES.indexOf(role) > -1;
        }
      },

      /**
       * @desc accessibilty attribute: hide content from screen readers
       * when dialog is open. if null, defaults to siblings of portal-target element
       */
      contentRoot: {
        type: [String, null],
        "default": null
      },

      /**
       * @desc focus-trap package configuration object
       * @see {@link https://github.com/focus-trap/focus-trap#usage}
       */
      focusTrapCreateOptions: {
        type: Object,
        "default": function _default() {
          return {};
        }
      }
    },
    data: function data() {
      return getInitialState$1();
    },
    watch: {
      open: {
        immediate: true,
        handler: function handler(open) {
          if (open) {
            this.handleOpen();
          } else {
            this.handleClose();
          }
        }
      }
    },
    methods: {
      /**
       * "open" prop watcher side effects. Orchestrates everything DOM related
       * with the open state of the dialog. nextTick because dom is conditionally
       * rendered with v-if on root node.
       *
       * @todo [1] - kind of embarassing but i need to investigate the need of
       * double nextTick, otherwise it will fail to get DOM refs from data-attrs.
       * I get that we need one, But two? Maybe due portal mount as well? Investigate.
       *
       * If found, please write a test to it,
       */
      handleOpen: function handleOpen() {
        var _this = this;

        this.$nextTick(function () {
          _this.$nextTick(function () {
            var hasRefs = _this.getDOMRefs(); // do no perform DOM actions if no DOM references


            if (!hasRefs) return;

            _this.toggleFocusTrap(true);

            _this.lookForSiblings();

            _this.toggleVisibilityEvents(true);

            _this.toggleContentAriaAttrs(true);
          });
        });
      },

      /**
      * "open" prop watcher side effects. Orchestrates everything DOM related
      * when dialog is closed, removing observers and added attributes
      */
      handleClose: function handleClose() {
        this.toggleFocusTrap(false);
        this.toggleVisibilityEvents(false);
        this.toggleContentAriaAttrs(false);
        this.resetData();
      },

      /**
       * Handle keyboard events on dialoRef element an manage which
       * method to call accordingly
       *
       * @param {Event} e - Javascript keyboard event
       */
      handleKeyboard: function handleKeyboard(e) {
        e.stopPropagation();
        var key = e.key,
            target = e.target;

        if (key === 'Escape') {
          // do not interfere with native input behaviour
          if (target.type === 'search' && target.value !== '') return;
          this.close(e);
        }
      },

      /**
       * @event Close - event for closing the dialog on the parent.
       * Internal side-effects are handled in "open" prop watcher
       */
      close: function close(event) {
        this.$emit('close', event);
      },

      /**
       * Usefull events for side-effects on open/close like preventing
       * background content scroll with a custom solution.
       * Overflow:hidden on body might not produce the desired effects
       * within nested contained content.
       * @event show
       * @event hide
       */
      toggleVisibilityEvents: function toggleVisibilityEvents(isOpen) {
        var hasSiblings = this.siblingsCount > 1;
        return isOpen ? this.$emit('show', hasSiblings) : this.$emit('hide', hasSiblings);
      },

      /**
       * We can't use vue refs bindings with scopedSlots so we look for the attached
       * ref data-attributes on elements instead.
       * @returns {Boolean} performs checks for other ref dependend methods
       */
      getDOMRefs: function getDOMRefs() {
        this.dialogRoot = document.querySelector("[data-id=\"a11y-vue-dialog-".concat(this._uid, "\"]"));

        if (this.dialogRoot) {
          this.dialogEl = this.dialogRoot.querySelector('[data-ref="dialog"]');
          this.closeEl = this.dialogRoot.querySelector('[data-ref="close"]');
          this.focusRef = this.dialogRoot.querySelector('[data-ref="focus"]');
          return true;
        }

        return false;
      },

      /**
       * Cleans component internal state (data object).
       * @todo implement a cache mechanism in case component wasn't destroyed.
       * #perf
       */
      resetData: function resetData() {
        // eslint-disable-next-line
        var _getInitialState = getInitialState$1(),
            resetData = _objectWithoutProperties(_getInitialState, ["id"]);

        Object.assign(this.$data, resetData);
      },

      /**
       * @see [FT1] - provided initial focus not found, it won't get the first focusable children
       *   {@link https://github.com/focus-trap/focus-trap/issues/113}
       * @see [FT2] - if click outside an focusable element, but inside dialog body, (do not focus
       *   first focus element (close button), it's weird. But keep focus within dialog. It's overrideable
       *   via focusTrapCreateOptions
       * @see [FT3]
       *   Some input components wrappers might inheriting attributes, meaning
       *   some <div autofocus> — this is an invalid focusable element — but we
       *   were getting it anyways, and focus-trap doesn't validate (and i agree)
       *   element so we changed our query to only select valid ones.
       *   @see {@link https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes}
       */
      toggleFocusTrap: function toggleFocusTrap(toggle) {
        if (toggle) {
          this.trap = createFocusTrap(this.dialogEl, _objectSpread2({
            escapeDeactivates: false,
            allowOutsideClick: true,
            initialFocus: this.focusRef || this.dialogEl.querySelector(AUTOFOCUS_QUERY),
            // [FT1] [FT3]
            fallbackFocus: this.dialogEl
          }, this.focusTrapCreateOptions));
          this.trap.activate();
        } else {
          if (this.trap) this.trap.deactivate();
        }
      },

      /**
       * Toggling aria-hidden on content other than dialog.
       * This is kind tricky and maybe we should just
       */
      // experimental for multiple modals
      lookForSiblings: function lookForSiblings() {
        this.portalTarget = this.dialogRoot.parentElement;
        this.siblingsCount = this.portalTarget.children.length;
      },

      /**
       * https://gomakethings.com/an-es6-way-to-get-all-sibling-elements-with-vanilla-js/
       */
      getSiblings: function getSiblings(elem) {
        return Array.from(elem.parentNode.children).filter(function (sibling) {
          return sibling !== elem;
        });
      },
      toggleContentAriaAttrs: function toggleContentAriaAttrs(isOpen) {
        // if theres already one open dialog, we don't need to toggle everything again.
        if (this.siblingsCount > 1) return;
        var contentRoot = this.contentRoot;
        var contentRootSiblings = []; // check if content-root prop is not null, in affirmative case
        // we just want to target it, nothing else

        if (contentRoot) {
          contentRootSiblings.push(document.querySelector(contentRoot));
        } else if (this.portalTarget) {
          // if not, we default to find the same level elements (siblings)
          // of portalTarget (where the focus is) and apply aria-attributes to hide
          // the rest of the contetn
          contentRootSiblings = this.getSiblings(this.portalTarget);
        }

        if (isOpen) {
          contentRootSiblings.forEach(function (s) {
            return s && s.setAttribute('aria-hidden', 'true');
          });
        } else {
          contentRootSiblings.forEach(function (s) {
            return s && s.removeAttribute('aria-hidden');
          });
        }
      },

      /**
      * Internals.
      *
      * mostly created for testing, because i didn't figure out a
      * away of mock funtions that are defined, inline into the scopedSlots
      * returned Object
      */
      _stopPropagation: function _stopPropagation(e) {
        e.stopPropagation();
      },

      /**
       * Prevents mouseup that started inside (dialogRef mousedown) to bubble
       * and trigger backdrop click, consequentially closing the dialog.
       *
       * ⚠️ Note: for cases when backdropRef wraps the dialog content,
       *    so it's also our root, that's why it's affected by children
       *    events bubbling
       *
       * This prevents a default browser behaviour, when the mouse click is released,
       * both the mouseup and click events are fired. Since consumers might define
       * backdrop as root (picture a pseudo element as the overlay for example)
       *
       * Setting as separate element inside the root doens't require this, but
       * we must remain unopinionated in relation to markup.
       *
       * @see https://stackoverflow.com/a/20290312/2801012
       * @see https://codesandbox.io/s/click-drag-selection-outside-still-triggers-click-after-mouseup-t0742
       *
       * @see captureMouseUp
       * @see spyMouseDown
       * @see spyMouseUp
       */
      captureMouseUp: function captureMouseUp(e) {
        e.stopPropagation(); // Stop the click from being propagated.

        window.removeEventListener('click', this.captureMouseUp, true); // cleanup

        this.mouseDownOrigin = null;
      },
      spyMouseDown: function spyMouseDown(e) {
        e.stopPropagation();
        this.mouseDownOrigin = e.target;
      },
      spyMouseUp: function spyMouseUp(e) {
        e.stopPropagation();

        if (this.mouseDownOrigin !== e.target) {
          // capture it: was triggered somewhere else
          window.addEventListener('click', this.captureMouseUp, true);
        }
      }
    },

    /**
     * @todo Lifecyle methods go crazy when called with nested modals pattern.
     * in default mode, destroyed is not called (and reasonably since it's the)
     * portal that is toggled with v-if not this one. But when nested is always
     * called. Needs investigation
     */
    created: function created() {
      this.id = "a11y-vue-dialog-".concat(this._uid);
    },
    beforeDestroy: function beforeDestroy() {
      this.handleClose();
    },

    /**
     * @slot binding to be applied to the defined elements. Each ref suffixed
     * binding is an object that contains a "props" and "listeners" keys to be
     * attached to elements via v-bind and v-on respectively
     *
     * @binding {Boolean} open - prop forwarding for portal v-if
     * @binding {Function} close - method forwarding for closing the dialog
     * @binding {Object} backdropRef - for the backdrop element
     * @binding {Object} dialogRef - for the main dialog element
     * @binding {Object} closeRef - for attching close buttons/actions
     * @binding {Object} titleRef - For attaching dialog title, for accessiblity
     *
     * @todo [1] - If some one selects text from the dialog, document.activeElement is
     *  set to the backdrop, even with tabindex="-1", so we need to bind keyboard events
     *  there as well so that dialog keeps closing on escape click. Not sure if
     *  the best way, but shipable for now
     *
     * @see [2] - It is strongly recommended that the tab sequence of all
     *  dialogs include a visible element with role button that closes the
     *  dialog, such as a close icon or cancel button.
     *  {@link https://www.w3.org/TR/wai-aria-practices/#dialog_modal}
     */
    render: function render() {
      return this.$scopedSlots["default"]({
        open: this.open,
        closeFn: this.close,
        backdropRef: {
          props: {
            'tabindex': '-1',
            'data-id': this.id,
            'data-ref': 'backdrop'
          },
          listeners: {
            click: this.role !== 'alertdialog' ? this.close : noop,
            keydown: this.handleKeyboard,
            // [1]
            mousedown: this.spyMouseDown,
            mouseup: this.spyMouseUp
          }
        },
        dialogRef: {
          props: {
            role: this.role,
            'data-ref': 'dialog',
            'aria-labelledby': "".concat(this.id, "-title"),
            tabindex: '-1' // [FT2]

          },
          listeners: {
            click: this._stopPropagation,
            keydown: this.handleKeyboard,
            mousedown: this.spyMouseDown,
            mouseup: this.spyMouseUp
          }
        },
        // [2]
        closeRef: {
          props: {
            'data-ref': 'close'
          },
          listeners: {
            click: this.close
          }
        },
        titleRef: {
          props: {
            id: "".concat(this.id, "-title")
          }
        },
        focusRef: {
          props: {
            'data-ref': 'focus'
          }
        }
      });
    }
  };

  /* script */
  var __vue_script__$2 = script$2;
  /* template */

  /* style */

  var __vue_inject_styles__$2 = undefined;
  /* scoped */

  var __vue_scope_id__$2 = undefined;
  /* module identifier */

  var __vue_module_identifier__$2 = undefined;
  /* functional template */

  var __vue_is_functional_template__$2 = undefined;
  /* style inject */

  /* style inject SSR */

  var A11yVueDialogRenderless = normalizeComponent_1({}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, undefined, undefined);

  var DEFAULTS = {
    componentName: "a11y-vue-dialog"
  };
  var Plugin = {
    install: function install(Vue) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      /**
       * Makes sure that plugin can be installed only once
       */
      if (this.installed) {
        return;
      }

      this.installed = true;
      this.componentName = options.componentName || DEFAULTS.componentName; // is there a better way of doing this
      // (extend default prop value on component registration)*

      if (options.props) {
        Object.keys(A11yVueDialog.props).map(function (propName) {
          if (options.props[propName]) {
            A11yVueDialog.props[propName]['default'] = options.props[propName];
          }
        });
      }

      Vue.component(this.componentName, A11yVueDialog);
    }
  };

  exports.A11yVueDialog = A11yVueDialog;
  exports.A11yVueDialogRenderless = A11yVueDialogRenderless;
  exports.default = Plugin;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=a11y-vue-dialog.umd.js.map
